import { Directive, HostBinding, HostListener, input } from '@angular/core';

@Directive({
  selector: '[nfpReadonlyGroup]',
  standalone: true
})
export class ReadOnlyGroupDirective {
  nfpReadonlyGroup  = input.required<boolean>();

  @HostBinding('class.nfp-readonly-group') 
  get readonlyClass(): boolean {
    return this.nfpReadonlyGroup();
  }

  @HostListener('keydown.tab', ['$event'])
  @HostListener('keydown.enter', ['$event'])
  onKeyboardClick(event: KeyboardEvent): void {
    if (!this.nfpReadonlyGroup()) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('focusin', ['$event'])
  onFocusIn(event: FocusEvent): void {
    if (!this.nfpReadonlyGroup()) {
      return;
    }
    const target = event.target as HTMLElement | null;
    target?.blur();
  }
}